import api from '../../config/httpClient';
import companyApi from '../../config/httpClient-company';
import * as DTOS from '../constants/app.dto';


export const getUserProfile = async (email: string) => {
  const result = await api.get(`/customers/email/${email}`);
  return result.data;
}

export const upsertUserProfile = async (data: Partial<DTOS.IUser>) => {
  const result = await api.post(`/customers`, data);
  return result.data;
}

export const patchUserProfile = async (id: string, data: Partial<DTOS.IUser>) => {
  const result = await api.patch(`/customers/${id}`, data);
  return result;
}

export const patchUserAddress = async (id: string, addressId: string, data: DTOS.IUserAddresses) => {
  const result = await api.patch(`/customers/${id}/addresses/${addressId}`, data);
  return result;
}

export const upsertUserAddress = async (id: string, data: DTOS.IUserAddresses) => {
  const result = await api.post(`/customers/${id}/addresses`, data);
  return result;
}

export const createUserFormation = async (id: string, data: any) => {
  const result = await api.post(`/customers/${id}/formationInfo`, data);
  return result;
}

export const createUserWorkExperience = async (id: string, data: any) => {
  const result = await api.post(`/customers/${id}/workExperiences`, data);
  return result;
}

export const createUserAddress = async (id: string, data: DTOS.IUserAddresses) => {
  const result = await api.post(`/customers/${id}/addresses`, data);
  return result;
}

export const uploadProfilePhoto = async (id: string, data: any) => {
  const result = await api.post(`/customers/${id}/image`, data);
  return result.data;
}

export const uploadDocument = async (id: string, data: any) => {
  const result = await api.post(`/customers/${id}/documents`, data);
  return result;
}

export const deleteUserExperience = async (id: string, experienceId: string) => {
  return await api.delete(`/customers/${id}/workExperiences/${experienceId}`);
}

export const deleteUserFormation = async (id: string, experienceId: string) => {
  return await api.delete(`/customers/${id}/formationInfo/${experienceId}`);
}

export const updateFavoriteOpportunity = (id: string, value: boolean) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(true), 800);
  })
}

export const hasValidProfile = async (email: string) => {
  const result = await api.get(`/customers/verify/${email}`);
  return result.data;
}

export const validateSubscription = async (cid: string, oid: string, userId: string) => {
  const response = await companyApi.get(`/companies/${cid}/opportunities/${oid}/subscription/customer?customerId=${userId}`);
  return response;
}

export const deleteDocument = async (userId: string) => {
  const response = await api.delete(`/customers/${userId}/documents`);
  return response;
}

export const validatePhoneRegistered = async (phone: string): Promise<DTOS.phoneVerified> => {
  const response = await api.get(`/customers/verify-cellphone/${phone}`);
  return response.data;
}